// Changer le texte du bouton
document.addEventListener('DOMContentLoaded', function () {
  const addToCartBtn = document.querySelector(
    'form[action="/cart/add"] [name="add"], form[action="/cart/add"] button[type="submit"]'
  );
  if (addToCartBtn) {
    const btnSpan = addToCartBtn.querySelector('span:not(.visually-hidden)');
    if (btnSpan && btnSpan.textContent.trim().length > 0) {
      btnSpan.textContent = 'Commander ma carte →';
    } else {
      addToCartBtn.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0) {
          node.textContent = 'Commander ma carte →';
        }
      });
    }
  }
});

// UID unique — compatible Easify
document.addEventListener('click', function (e) {
  const btn = e.target.closest('button[type="submit"], [data-add-to-cart], .easify-atc-btn, button[name="add"]');
  if (!btn) return;

  const form = btn.closest('form');
  if (!form) return;

  let uidInput = form.querySelector('input[name="properties[_uid]"]');
  if (!uidInput) {
    uidInput = document.createElement('input');
    uidInput.type = 'hidden';
    uidInput.name = 'properties[_uid]';
    form.appendChild(uidInput);
  }
  uidInput.value = Date.now() + '-' + Math.random().toString(36).substring(2, 7);
}, true);

// Afficher le prix sous chaque bouton de variante
function injectVariantPrices(product) {
  const inputs = document.querySelectorAll('variant-picker input[type="radio"]');
  inputs.forEach(input => {
    const variant = product.variants.find(v => v.title === input.value);
    if (!variant) return;

    const label = input.closest('label.variant-option__button-label');
    if (!label) return;

    if (label.querySelector('.variant-price')) return;

    const price = (variant.price / 100).toFixed(2);
    const priceEl = document.createElement('span');
    priceEl.className = 'variant-price';
    priceEl.style.cssText = 'display:block; font-size:0.8em; opacity:0.75; margin-top:2px;';
    priceEl.textContent = `${price} $`;
    label.appendChild(priceEl);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
  if (!productHandle) return;

  fetch(`/products/${productHandle}.js`)
    .then(res => res.json())
    .then(product => {
      // Injection initiale
      injectVariantPrices(product);

      // Réinjecter à chaque changement de variante
      const variantPicker = document.querySelector('variant-picker');
      if (variantPicker) {
        const observer = new MutationObserver(() => injectVariantPrices(product));
        observer.observe(variantPicker, { childList: true, subtree: true });
      }
    });
});